// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".chapter-indicators__container[data-v-01f5feb4]{position:absolute;top:0;right:0;left:0;bottom:0}.chapter-indicators__indicator[data-v-01f5feb4]{position:absolute;width:2px;top:0;bottom:0}.chapter-indicators__indicator-full-screen[data-v-01f5feb4]{background-color:#BDBDBD}.chapter-indicators__indicator-default[data-v-01f5feb4]{background-color:#6c26d6}\n", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
